export function FlightCardSkeleton() {
  return (
    <div className="flex w-full animate-pulse overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      {/* Left section - Flight info */}
      <div className="flex flex-1 flex-col p-6">
        {/* Header with airline */}
        <div className="mb-4 flex items-center justify-between">
          <div className="h-6 w-32 rounded bg-gray-200" />
        </div>

        {/* Outbound flight segment */}
        <div className="mb-4">
          <div className="flex items-center justify-between gap-4">
            <div className="min-w-20 space-y-2">
              <div className="h-6 w-16 rounded bg-gray-200" />
              <div className="h-4 w-24 rounded bg-gray-200" />
            </div>
            <div className="flex flex-1 flex-col items-center">
              <div className="h-4 w-20 rounded bg-gray-200" />
              <div className="my-2 h-0.5 w-full bg-gray-200" />
              <div className="h-3 w-12 rounded bg-gray-200" />
            </div>
            <div className="min-w-20 space-y-2 text-right">
              <div className="ml-auto h-6 w-16 rounded bg-gray-200" />
              <div className="ml-auto h-4 w-24 rounded bg-gray-200" />
            </div>
          </div>
        </div>

        {/* Return flight segment */}
        <div className="mb-4 border-t border-gray-100 pt-4">
          <div className="flex items-center justify-between gap-4">
            <div className="min-w-20 space-y-2">
              <div className="h-6 w-16 rounded bg-gray-200" />
              <div className="h-4 w-24 rounded bg-gray-200" />
            </div>
            <div className="flex flex-1 flex-col items-center">
              <div className="h-4 w-20 rounded bg-gray-200" />
              <div className="my-2 h-0.5 w-full bg-gray-200" />
              <div className="h-3 w-12 rounded bg-gray-200" />
            </div>
            <div className="min-w-20 space-y-2 text-right">
              <div className="ml-auto h-6 w-16 rounded bg-gray-200" />
              <div className="ml-auto h-4 w-24 rounded bg-gray-200" />
            </div>
          </div>
        </div>

        {/* Payment link */}
        <div className="mb-4">
          <div className="h-4 w-48 rounded bg-gray-200" />
        </div>

        {/* Luggage info */}
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <div className="h-5 w-5 rounded bg-gray-200" />
            <div className="h-4 w-32 rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-5 w-5 rounded bg-gray-200" />
            <div className="h-4 w-28 rounded bg-gray-200" />
          </div>
        </div>
      </div>

      {/* Right section - Pricing */}
      <div className="flex w-68 flex-col justify-between bg-gray-50 p-6">
        <div className="flex flex-col gap-2">
          {/* Price per adult */}
          <div className="mb-1 flex items-baseline gap-1">
            <div className="h-8 w-20 rounded bg-gray-200" />
            <div className="h-4 w-16 rounded bg-gray-200" />
          </div>

          {/* Price details */}
          <div className="mb-4 h-4 w-24 rounded bg-gray-200" />

          {/* Total price */}
          <div className="flex items-center justify-between">
            <div className="h-5 w-12 rounded bg-gray-200" />
            <div className="h-6 w-24 rounded bg-gray-200" />
          </div>
        </div>

        <div className="space-y-4">
          <div className="h-4 w-40 rounded bg-gray-200" />
          {/* Select button */}
          <div className="h-10 w-full rounded bg-gray-200" />
        </div>
      </div>
    </div>
  )
}
